import React from 'react';
import LazyImage from '@/components/ui/LazyImage';
import FavoriteButton from '@/components/FavoriteButton';
import ProviderStatusBadges from '@/components/ProviderStatusBadges';

interface ServiceProfileHeaderProps {
  id: string;
  name: string;
  image: string;
  areaSummaryLabel: string;
  whatsappVerified: boolean;
  isTopRated: boolean;
  isFeatured?: boolean;
}

export const ServiceProfileHeader: React.FC<ServiceProfileHeaderProps> = ({
  id,
  name,
  image,
  areaSummaryLabel,
  whatsappVerified,
  isTopRated,
  isFeatured = false,
}) => {
  return (
    <div className="relative bg-brand-ink">
      <div className="w-full aspect-[16/9] overflow-hidden md:aspect-[21/9]">
        <LazyImage src={image} alt={name} aspect="16/9" className="object-cover" wrapperClassName="w-full h-full" />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-brand-ink via-brand-ink/75 to-brand-ink/20" />
      </div>
      <img src={image} alt="" className="hidden" aria-hidden="true" />
      <div className="absolute bottom-0 left-0 max-w-[92%] p-4 sm:p-6">
        <h1 className="font-heading text-h1 font-bold leading-tight text-white">{name}</h1>
        <div className="mt-2 flex flex-wrap items-center gap-2 text-white/85">
          <span className="text-sm">{areaSummaryLabel}</span>
        </div>
      </div>
      <ProviderStatusBadges
        isFeatured={isFeatured}
        isTopRated={isTopRated}
        isVerified={whatsappVerified}
        className="absolute left-3 top-3 z-10"
      />

      <div className="absolute right-3 top-3">
        <FavoriteButton providerId={id} size="md" className="bg-white/90 hover:bg-white" />
      </div>
    </div>
  );
};
